import React from "react";
import "./Plans.css";
import { plansData } from "../../data/plansData";
import whiteTick from "../../assets/whiteTick.png";
import whatsapp2 from "../../assets/whatsapp";

const Plans = () => {
  return (
    <>
      <div id="plans" className="div0"></div>
      <div className="plans-container">
        <div className="blur plans-blur1"></div>
        <div className="blur plans-blur2"></div>
        <div className="plans-header">
          <span className="title-p">PLANES</span>
        </div>
        {/* Plans */}
        <div className="plans">
          {plansData.map((plan, i) => (
            <div className="plan" key={i}>
              {/* Ocultar el icono en el primer y tercer card */}
              <div className="plan-icon" style={{ display: i === 0 || i === 2 ? "none" : "block" }}>
                {plan.icon}
              </div>
              <span className="plan-name">{plan.name}</span>
              <span className="plan-price">$ {plan.price}</span>
              {/* Ocultar el mensaje en el primer card */}
              {i !== 0 && (
                <span className="plan-discount">Débito automático (exoneración de matrícula)</span>
              )}
              <div className="features">
                {plan.features.map((feature, j) => (
                  <div className="feature" key={j}>
                    <img src={whiteTick} alt="" className="feature-icon" />
                    <span className="feature-text">{feature}</span>
                  </div>
                ))}
              </div>
              {/* Botón con estilos actualizados */}
              <a
                href={
                  i === 0
                    ? "https://wa.me/59898057404"
                    : i === 1
                      ? "https://suscripciones.handy.uy/planes/229f5948-24b4-4eb9-9ffd-667673e98592/32504cf7-f3ce-4b04-826f-2d957afdeee8"
                      : "https://suscripciones.handy.uy/planes/229f5948-24b4-4eb9-9ffd-667673e98592/43b89d6c-d746-4ca3-b33a-e0f16bd23315"
                }
                target="_blank"
                rel="noreferrer"
                className="plan-button-wrapper"
                style={{ textDecoration: "none" }}
              >
                <button className="btn btn-p plan-button">Empezar Ahora!</button>
              </a>
            </div>
          ))}
        </div>
        <div className="legal">
          <div>
            <p>
              Las cuponeras tienen una vigencia de 30 días a partir del día que
              se realiza el pago.
            </p>
            <p>
              Podes asociar tarjeta de débito o crédito (Visa, Master u OCA)

              Mes a mes (con matrícula de $2.000 el primer mes)
              •⁠  ⁠12 clases: $2.200
              •⁠  ⁠Pase libre: $2.600
            </p>
            <p>
              *Formas de pago: efectivo, transferencia bancaria o débito automático (VISA, Máster u OCA).
            </p>
          </div>
          <a href="https://wa.me/59898057404" target="_blank" rel="noreferrer">
            <img src={whatsapp2} className="img2" alt="" />
          </a>
        </div>
      </div>
    </>
  );
};

export default Plans;
